import {
  FormFieldList,
  SfCheckboxFormField,
  SfTextAreaFormField,
  SfUtils,
} from 'ngx-smart-form';
import { PresentationSheet } from './models/presentation-sheet';

export const presentationSheetFields = (value?: PresentationSheet) => {
  let fields: FormFieldList<PresentationSheet> = [
    [
      new SfTextAreaFormField({
        formControlName: 'relazione',
        label: 'Eventuali indicatori di anomalia rilevati',
        required: true,
      }),
    ],
  ];

  fields = SfUtils.assignInitialValue(fields, value);

  return fields;
};
